export function uniformRandom(min = -1, max = 1): number {
  return Math.random() * (max - min) + min;
}

export function randomChoice<T>(choices: T[]): T {
  return choices[Math.floor(Math.random() * (choices.length - 1))];
}
